import {
  CheckboxField,
  NumberField,
  ObjectField,
  SelectField,
  TextField,
} from "~/components/Form";
import {
  NewLqsResourceForm,
  ProcessState,
  processStateOptions,
  useCreateIngestionPart,
  WorkflowSelect,
} from "~/lqs";
import { makeIngestionPartLocation, useIngestionParams } from "~/paths";
import { createIngestionPartSchema } from "../schemas";

export function IngestionPartCreateForm() {
  const { ingestionId } = useIngestionParams();

  return (
    <NewLqsResourceForm
      schema={createIngestionPartSchema}
      defaultValues={{
        sequence: null,
        source: null,
        state: ProcessState.Ready,
        workflowId: null,
        workflowContext: null,
        locked: false,
      }}
      resourceName="ingestion part"
      mutation={useCreateIngestionPart(ingestionId)}
      createDetailsLocation={(response) =>
        makeIngestionPartLocation({
          ingestionId,
          ingestionPartId: response.data.id,
        })
      }
    >
      {(control) => (
        <>
          <NumberField control={control} name="sequence" required />
          <TextField control={control} name="source" />
          <SelectField
            control={control}
            name="state"
            options={processStateOptions}
            required
          />
          <WorkflowSelect control={control} name="workflowId" />
          <ObjectField control={control} name="workflowContext" />
          <CheckboxField control={control} name="locked" />
        </>
      )}
    </NewLqsResourceForm>
  );
}
